import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { roleSatisfies } from '@/hooks/usePermissions';
import { useSettings } from '@/hooks/useSettings';
import { navEntries, type NavEntry } from './registry';

export interface VisibleNavItem extends NavEntry {
  /** 1-based position among visible items; Alt+<n> opens it (only 1..9 get a shortcut). */
  index: number;
  shortcut: string | null;
}

/** Sidebar items for the current user: role + feature-flag filtered, in registry order. */
export function useNavItems(): VisibleNavItem[] {
  const { user } = useAuth();
  const { settings } = useSettings();
  const role = user?.role;

  return useMemo(() => {
    const visible = navEntries.filter(
      (e) => roleSatisfies(role, e.audience) && (!e.feature || settings[e.feature]),
    );
    return visible.map((e, i) => ({
      ...e,
      index: i + 1,
      shortcut: i < 9 ? `alt+${i + 1}` : null,
    }));
  }, [role, settings]);
}
